export default function getMailAriaTenantTokens(): string[] {
    return ['56468f6991c348029c6bba403b444607-7f5d6cd1-7fbe-4ab1-be03-3b2b6aeb3eb4-7696'];
}

export function getCLPAriaTenantTokens(): string {
    return '20ed4f5863d145bb9b9811c0f016da47-0f867f8d-a0be-44dc-b557-6da8178006f7-7559';
}
